module.exports = require("@wordpress/block-editor");